/**
 * Override warning to get rid of unsafe warnings in pdf styled components
 */
const warn = console.warn
import _ from 'lodash'
function logWarning(...warnings) {
  let showWarning = true
  warnings.forEach(warning => {
    if (showWarning && _.isString(warning)) {
      showWarning = !warning.includes("UNSAFE_")
                    && !warning.includes("SourceMap")
                    && !warning.includes("DevTools")
                    && !warning.includes('Added non-passive event listener to a scroll-blocking')
                    && !warning.includes('Out of bound indices will not be tracked by MobX')
    }
  })
  if (!TEST && showWarning) warn(...warnings)
}

console.warn = logWarning


// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/warning.ts